import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { metronic } from "../../_metronic";
import * as filter from "./ducks/FilterReducer";
import * as alert from "./ducks/AlertReducer";
import * as sound from "./ducks/SoundReducer";
import * as portal from "./ducks/PortalReducer";
import * as record from "./ducks/RecordReducer";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  filter: filter.reducer,
  alert: alert.reducer,
  sound: sound.reducer,
  portal: portal.reducer,
  record: record.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
